import React from 'react';
import styles from './XAxisItem.module.scss';
import classnames from 'classnames';

interface Tooltip {
  index: number;
}

interface Column {
  name?: string;
  value: number | null;
  relativeValue: number;
  isReversed: boolean;
}

export interface XValue {
  columns: Column[];
  tooltips: Tooltip[];
  year: string | number;
}

interface XAxisItemProps {
  xValue: XValue;
  columnBottomOffset: string;
  hasNegativeColumn?: boolean;
}

const XAxisItem: React.FC<XAxisItemProps> = ({
  xValue,
  columnBottomOffset,
  hasNegativeColumn = false,
}) => {
  return (
    <div
      className={classnames(styles['x-axis-item'], {
        [styles['negative-column-present']]: hasNegativeColumn,
      })}
    >
      <div className={styles['columns-group']}>
        {xValue.columns.map((column, idx) => (
          <div
            key={column.name}
            className={styles.column}
            title={column.value !== null ? `${column.value}%` : ''}
          >
            <span
              className={styles.bar}
              style={{
                height: `${column.relativeValue}%`,
                bottom: `calc(${columnBottomOffset} + 0.5px)`,
                transform: column.isReversed ? 'translateY(100%)' : '',
              }}
            >
              {idx === 0 && (
                <>
                  {xValue.tooltips.map((tooltip, tooltipIdx) => (
                    <span
                      key={tooltip.index}
                      className={`${styles['column__tooltip']} caption`}
                      style={
                        column.isReversed
                          ? {
                              top: '100%',
                              transform: `translateX(-50%) translateY(${tooltipIdx * 200}%)`,
                            }
                          : {
                              bottom: '100%',
                              transform: `translateX(-50%) translateY(-${tooltipIdx * 200}%)`,
                            }
                      }
                    >
                      {tooltipIdx + 1}
                    </span>
                  ))}
                </>
              )}
            </span>
          </div>
        ))}
      </div>
      <div className={`${styles['x-axis-item__legend']} body-small`}>{xValue.year}</div>
    </div>
  );
};

export default XAxisItem;
